import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  Avatar,
  Typography,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  CssBaseline,
  Box,
  useMediaQuery,
  Badge,
  MenuItem,
  Menu,
  Modal,
  FormControlLabel,
  FormControl,
  InputLabel,
  Switch,
  Select,
  Grid,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import LockResetIcon from "@mui/icons-material/LockReset";

import avatar from "../../Assets/Images/close-up-portrait-young-bearded-man-white-shirt-jacket-posing-camera-with-broad-smile-isolated-gray_171337-629.jpg";

import ChangePasswordModalCandidate from "../Modals/ChangePasswordModalCandidate";

import CommonButton from "../InputComponents/CommonButton";
import SelectInput from "../InputComponents/SelectInput";
import { CandidateLayoutProvider } from "../Context/CandidateLayoutContext";
import { axiosAPI } from "../AxiosComponents/Axios";

const menuItems = [
  {
    label: "Dashboard",
    icon: (
      <HomeIcon sx={{ fontSize: "25px", position: "relative", right: "4px" }} />
    ),
    path: "/",
  },

  // {
  //   label: "My Profile",
  //   icon: (
  //     <PersonIcon
  //       sx={{ fontSize: "25px", position: "relative", right: "4px" }}
  //     />
  //   ),
  //   path: "/Profile",
  // },
  // {
  //   label: "Logout",
  //   icon: (
  //     <LogoutIcon
  //       sx={{ fontSize: "25px", position: "relative"}}
  //     />
  //   ),

  // },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function NavbarSidebarLayoutCandidate({
  viewNav = true,
  children,
}) {
  const isMobile = useMediaQuery("(max-width: 1220px)");
  const Navigate = useNavigate();
  const location = useLocation();

  const [openModal, setOpenModal] = useState(false);

  const [autoDelete, setAutoDelete] = useState(true);
  const [deleteFrequency, setDeleteFrequency] = useState("7");

  const [FontFamilyValue, setFontFamily] = useState("Geist, sans-serif");

  const [isCollapsed, setIsCollapsed] = useState(false);

  const [notificationCount, setNotificationCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const [openSubMenu2, setOpenSubMenu2] = useState(null);

  useEffect(() => {
    const activeMenu = menuItems.find((item) =>
      item.subItems?.some((subItem) => subItem.path === location.pathname)
    );

    if (activeMenu) {
      setOpenSubMenu2(activeMenu.label);
    }
  }, [location.pathname]);

  const handleSubMenuToggle2 = (label) => {
    setOpenSubMenu2((prev) => (prev === label ? null : label));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const [candidateData, setCandidateData] = useState({});
  const [candidateJobData, setCandidateJobData] = useState([]);
  const [notifications, setNotifications] = useState([]);

  const [apiCalled, setAPICalled] = useState(false);

  const getData = async () => {
    try {
      const res = await axiosAPI.get(
        `/candidateportal/basicdetails/${
          localStorage?.getItem("SWA_UserId") ||
          sessionStorage?.getItem("SWA_UserId")
        }`
      );
      setCandidateData(res?.data?.data);
      setAPICalled(!apiCalled);
    } catch (err) {
      console.error(err);
    }
  };

  const getCandidateJobDetails = async () => {
    try {
      const res = await axiosAPI.get(
        `/candidateportal/jobdetails/${
          localStorage?.getItem("SWA_UserId") ||
          sessionStorage?.getItem("SWA_UserId")
        }`
      );
      setCandidateJobData(res?.data?.data);
      setAPICalled(!apiCalled);
    } catch (err) {
      console.error(err);
    }
  };

  const getNotification = async () => {
    try {
      const res = await axiosAPI.post(`/Notification/list`, {
        UserId:
          localStorage?.getItem("SWA_UserId") ||
          sessionStorage?.getItem("SWA_UserId"),
      });
      setNotifications(res?.data?.data);

      const unreadNotifications = res?.data?.data?.filter(
        (item) => item.NM_isRead === 0
      );

      setNotificationCount(unreadNotifications?.length);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getData();
    getCandidateJobDetails();
    getNotification();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        margin: "0px",
      }}
    >
      <ChangePasswordModalCandidate
        open={openModal}
        onClose={() => setOpenModal(false)}
      />
      <CssBaseline />

      {/* Sidebar */}

      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isCollapsed || !isMobile}
        onClose={() => setIsCollapsed(false)}
        sx={{
          display: viewNav ? "block" : "none",
          width: isMobile ? 240 : isCollapsed ? 135 : 260,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            transition: "width 0.3s ease-in-out",
            width: isMobile ? 240 : isCollapsed ? 135 : 260,
            background: "#006CB8",
            color: "white",

            margin: isMobile ? "0px" : "0px 10px 0px 0px",
            border: "2px solid #006CB8",

            overflowX: "hidden",
          },
        }}
      >
        <List
          sx={{
            background: "#006CB8",
            minHeight: "76px",
          }}
        >
          {!isMobile && (
            <IconButton
              edge="start"
              sx={{
                position: "relative",
                left: isCollapsed ? "10px" : "17px",
                transition: "all 0.1s ease-in-out",
              }}
            >
              <MenuIcon
                sx={{ color: "white", fontSize: "40px" }}
                onClick={() => setIsCollapsed(!isCollapsed)}
              />
            </IconButton>
          )}
        </List>

        <List sx={{ padding: "0px" }}>
          {menuItems.map((item, index) => {
            const isSubMenuOpen = openSubMenu2 === item.label;
            const hasSubItems = !!item.subItems;
            const isSubItemActive = item.subItems?.some(
              (sub) => sub.path === location.pathname
            );
            const isItemActive =
              !hasSubItems && item.path === location.pathname;

            const isActiveCollapsed =
              isCollapsed && (isItemActive || isSubItemActive);
            const isActiveExpanded = !isCollapsed && !isMobile && isItemActive;

            const isActive = isActiveCollapsed || isActiveExpanded;

            const parentStyles = {
              color: isActive ? "#006CB8" : "white",
              background: isActive ? "white" : "#006CB8",
              fontweight: isActive ? "700" : "600",
              cursor: "pointer",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: isActive ? "white" : "#006CB8",
                color: isActive ? "#006CB8" : "white",
                transition: "all 0.3s ease-in-out",
              },
            };

            return (
              <div key={index}>
                <ListItem
                  button
                  onClick={() => {
                    // if sidebar is closed, clicking the icon with submenu wont toggle submenu. Just the whole sidebar will be opened or closed
                    if (!isCollapsed || isMobile) {
                      handleSubMenuToggle2(item.label);
                    }

                    // if sidebar is closed,
                    // and viewport is not for mobile,
                    // and if item has submenu, sidebar will open
                    if (isCollapsed && !isMobile && hasSubItems) {
                      setIsCollapsed(false);
                    }

                    // if viewport is for mobile, and if you click item without submenu, the sidebar will close.
                    // if sidebar item has a submenu, the main item will not cause sidebar to close.
                    else if (isMobile && !hasSubItems) {
                      setIsCollapsed(false);
                    }
                  }}
                  component={!hasSubItems ? Link : "div"}
                  to={!hasSubItems ? item.path : undefined}
                  sx={{
                    ...parentStyles,
                    minHeight: "60px",
                    borderRadius: "0px 20px 20px 0px",
                    justifyContent:
                      isCollapsed && !isMobile ? "center" : "center",
                    px: 2,
                    clipPath:
                      "polygon(0 0, calc(100% - 40px) 0, 100% 50%, calc(100% - 40px) 100%, 0 100%)",

                    // border:'2px solid red'
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: isActive ? "#006CB8" : "white",
                      minWidth: 0,
                      mr: 2,
                      justifyContent: "center",
                      position: "relative",
                      left: isMobile ? "0px" : isCollapsed ? "37px" : "0px",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>

                  <ListItemText
                    primary={item.label}
                    sx={{ textWrap: "nowrap" }}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: FontFamilyValue,
                        opacity: !isCollapsed || isMobile ? 1 : 0,
                        display: !isCollapsed || isMobile ? "block" : "none",
                        fontSize: "15px",
                        fontWeight: "500",
                      },
                    }}
                  />

                  {hasSubItems &&
                    (!isCollapsed || isMobile) &&
                    (isSubMenuOpen ? <ExpandLess /> : <ExpandMore />)}
                </ListItem>

                {/* Submenu */}
                {hasSubItems && (!isCollapsed || isMobile) ? (
                  <Collapse in={isSubMenuOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.subItems.map((subItem, subIndex) => {
                        const isSubActive = location.pathname === subItem.path;

                        return (
                          <ListItem
                            key={subIndex}
                            button
                            component={Link}
                            to={subItem.path}
                            onClick={() => {
                              if (isMobile) {
                                // if mobile viewport, clicking the submenu item
                                // will close the sidebar
                                setIsCollapsed(false);
                              }
                            }}
                            sx={{
                              pl: 4,
                              minHeight: "48px",
                              color: isSubActive ? "#006CB8" : "white",
                              background: isSubActive ? "white" : "#006CB8",
                              transition: "all 0.3s ease-in-out",

                              "&:hover": {
                                backgroundColor: isSubActive
                                  ? "white"
                                  : "#055C9D",
                                color: isSubActive ? "#006CB8" : "white",
                                transition: "all 0.3s ease-in-out",
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                color: isSubActive ? "#006CB8" : "white",
                                position: "relative",
                                left: "30px",
                              }}
                            >
                              {subItem.icon}
                            </ListItemIcon>

                            <ListItemText
                              primary={subItem.label}
                              primaryTypographyProps={{
                                sx: {
                                  fontFamily: FontFamilyValue,
                                  fontSize: "15px",
                                  fontWeight: "400",
                                },
                              }}
                            />
                          </ListItem>
                        );
                      })}
                    </List>
                  </Collapse>
                ) : null}
              </div>
            );
          })}
        </List>
      </Drawer>

      {/* Main Content Area */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100vh",
        }}
      >
        {/* Navbar */}

        <AppBar
          position="static"
          sx={{
            minHeight: "80px", // Ensures a minimum height of 100px
            background: "white",
            color: "black",
            px: 2,
            display: viewNav ? "flex" : "none",
            justifyContent: "center", // Centers the content vertically
            boxShadow: "none",
            borderBottom: "2px solid #E4E4E7",
          }}
        >
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "100%",
            }}
          >
            {/* Left Section */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {isMobile && (
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => setIsCollapsed(!isCollapsed)}
                >
                  <MenuIcon sx={{ color: "black", fontSize: "40px" }} />
                </IconButton>
              )}
            </Box>

            {/* Right Section */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mt: 1,
                mr: 3,
              }}
            >
              {/* Notifications Icon with Badge */}
              <IconButton color="inherit">
                <Badge badgeContent={notificationCount} color="error">
                  <NotificationsNoneIcon
                    sx={{ color: "black", fontSize: "40px" }}
                    onClick={() => {
                      if (notificationCount) {
                        Navigate(`/Notifications`);
                      }
                    }}
                  />
                </Badge>
              </IconButton>

              {/* Profile Section */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  cursor: "pointer",
                }}
              >
                <Avatar
                  src={`${process.env.REACT_APP_BASE_URL}/${candidateData?.CI_Photo}`}
                  sx={{
                    width: 50,
                    height: 50,
                    transition: "border 0.3s ease",
                    border: "2px solid transparent",
                    "&:hover": {
                      border: "2px solid #1976d2", // or any color you prefer
                    },
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    Navigate(`/Profile`);
                  }}
                />

                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  {candidateData?.CI_Alias && candidateData?.CI_Name ? (
                    <>
                      <Typography
                        sx={{
                          fontFamily: FontFamilyValue,
                          color: "black",
                          fontSize: "18px",
                          position: "relative",
                          top: "8px",
                        }}
                        onClick={() => {
                          Navigate(`/Profile`);
                        }}
                      >
                        {candidateData.CI_Name}
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: FontFamilyValue,
                          color: "black",
                          fontSize: "12px",
                          position: "relative",
                          bottom: "5px",
                        }}
                      >
                        {candidateData.CI_Alias}
                        <IconButton onClick={handleClick}>
                          <ExpandMoreIcon sx={{ color: "black" }} />
                        </IconButton>
                      </Typography>
                    </>
                  ) : (
                    <Typography
                      sx={{
                        fontFamily: FontFamilyValue,
                        color: "black",
                        fontSize: "18px",
                        position: "relative",
                      }}
                    >
                      {candidateData?.CI_Name || candidateData.CI_Alias}
                      <IconButton onClick={handleClick}>
                        <ExpandMoreIcon sx={{ color: "black" }} />
                      </IconButton>
                    </Typography>
                  )}
                </Box>

                {/* Dropdown Menu */}
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Adjusts initial position
                  transformOrigin={{ vertical: "top", horizontal: "right" }} // Controls where it expands from
                  sx={{
                    "& .MuiPaper-root": {
                      width: "200px", // Adjust width
                      marginTop: "25px", // Moves it further down
                      borderRadius: "8px", // Optional: Rounded corners,
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      Navigate(`/Profile`);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        sx: { fontFamily: FontFamilyValue },
                      }}
                      primary="Profile"
                    />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setOpenModal(true);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <LockResetIcon />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        sx: { fontFamily: FontFamilyValue },
                      }}
                      primary="Change Password"
                    />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      localStorage.removeItem("SWA_userRole");
                      localStorage.removeItem("SWA_token");
                      localStorage.removeItem("SWA_UserId");
                      sessionStorage.removeItem("SWA_userRole");
                      sessionStorage.removeItem("SWA_token");
                      sessionStorage.removeItem("SWA_UserId");

                      Navigate("/Login");
                      window.location.reload();
                    }}
                  >
                    <ListItemIcon>
                      <LogoutIcon />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        sx: { fontFamily: FontFamilyValue },
                      }}
                      primary="Logout"
                    />
                  </MenuItem>
                </Menu>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Content View */}
        <CandidateLayoutProvider
          value={{
            candidateData,
            candidateJobData,
            notifications,
            triggerSomethingFromLayout: getNotification, // <- add function
          }}
        >
          {/* Navbar & Sidebar here */}
          <Box sx={{ flex: 1, overflowY: "auto", backgroundColor: "white" }}>
            {children}
          </Box>
        </CandidateLayoutProvider>
      </Box>

      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-settings-title"
        aria-describedby="modal-settings-description"
      >
        <Box
          sx={{
            ...style,
            p: 3,
            borderRadius: 3,
            backgroundColor: "#fff",
            width: 400,
            border: "none",
          }}
        >
          <Typography id="modal-settings-title" variant="h6" mb={2}>
            Personalised Settings
          </Typography>

          {/* Custom SelectInput for Notification Medium */}
          <SelectInput
            placeholder="Choose Notification Medium"
            name="notification_medium"
            // value={staffData.notification_medium}
            // onChange={handleInputChange}
            // error={!!errors.notification_medium}
            options={[
              { value: "email", label: "Email" },
              { value: "sms", label: "SMS" },
              { value: "push", label: "Push Notification" },
            ]}
          />

          <FormControlLabel
            control={
              <Switch
                checked={autoDelete}
                onChange={(e) => setAutoDelete(e.target.checked)}
              />
            }
            label="Auto delete notifications"
            sx={{ my: 2 }}
          />

          {autoDelete && (
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="delete-frequency-label">
                Delete Frequency
              </InputLabel>
              <Select
                labelId="delete-frequency-label"
                id="delete-frequency"
                value={deleteFrequency}
                label="Delete Frequency"
                onChange={(e) => setDeleteFrequency(e.target.value)}
              >
                <MenuItem value="1">After 1 day</MenuItem>
                <MenuItem value="7">After 7 days</MenuItem>
                <MenuItem value="30">After 30 days</MenuItem>
              </Select>
            </FormControl>
          )}

          {/* Buttons */}
          <Grid
            container
            spacing={2}
            justifyContent={{ xs: "center", sm: "flex-end" }}
          >
            <Grid item>
              <CommonButton
                variant="outlined"
                customColor="#B0BEC5"
                onClick={handleClose2}
              >
                Cancel
              </CommonButton>
            </Grid>
            <Grid item>
              <CommonButton
                variant="contained"
                customColor="#007BFF"
                onClick={handleClose2}
              >
                Save
              </CommonButton>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}
